
import PullMarketData from '/src/services/ProcessingHousingMkt/PullMarketData';
import householdIncomeConfig from '/src/services/ProcessingHousingMkt/HouseholdIncomeChartConfig.json';
// import BackupFEMAData from '/src/services/ProcessingHousingMkt/backupFemaData.json';
import LTVCalculators from '/src/services/LTVCalculators';
import CalculateMarketGrowthRates from '/src/services/CalculateMarketGrowthRates';
import ScoreMarketData from '/src/services/ProcessingHousingMkt/ScoreMarketData';
import NEWScoreMarketData from '/src/services/ProcessingHousingMkt/NEWScoreMarketData';
import marketDataKeys from '/src/services/ProcessingHousingMkt/MarketDataKeys.json';
export default function ProcessMarketDataMaster(propertyData, geoData) {

    // console.log('In the ProcessMarketDataMaster function', propertyData, geoData, householdIncomeConfig);
    // Return null if the propertyData or geoData is not set
    if (!propertyData || !geoData) {
        return null;
    }

    // Pull the market data
    const fipsData = geoData.fips
    const zipData = geoData.zip
    const stateData = geoData.state

    // Pull the fema data
    const femaData = fipsData?.fema_data || {};
    const disaster_declarations_list = femaData?.detailed_records?.disaster_declarations || []
    const disaster_declarations_list_state = stateData?.fema_data?.state_level?.detailed_records?.disaster_declarations || []
    const disaster_declarations_list_state_all_counties = stateData?.fema_data?.county_level?.detailed_records?.disaster_declarations || []

    // Filter the disaster_declarations_list to only include disasters with a year of 2021 or later
    const filteredDisasterDeclarationsList = disaster_declarations_list.filter(disaster => disaster.year >= 2021)
    const filteredDisasterDeclarationsListState = disaster_declarations_list_state.filter(disaster => disaster.year >= 2021)

    // Get the fips and zip housing market data from the fips and zip data
    const fipsHousingMarketData = fipsData.data
    const zipHousingMarketData = zipData.data

    // RETURN EARLY IF ANY OF THE DATA IS MISSING
    if (!fipsHousingMarketData || !zipHousingMarketData || !fipsData || !zipData || !propertyData) {
        return null;
    }

    // const marketDataKeys = [
    //     // {
    //     //     id: 'avg_sale_to_list',
    //     //     label: 'Average Sale Price to List Price Ratio',
    //     //     displayOption: 'both',
    //     //     dataType: 'ratio',
    //     //     twoYAxis: false,
    //     //     badDirection: 'down',
    //     //     weighting: .75
    //     // },
    //     {
    //         id: 'new_listings_to_sales_ratio',
    //         label: 'New Homes Listed to Homes Sold Ratio',
    //         ratioDatapoints: ['new_listings', 'homes_sold'],
    //         displayOption: 'both',
    //         dataType: 'ratio',
    //         twoYAxis: false,
    //         badDirection: 'up',
    //         weighting: 1,
    //     },
    //     // {
    //     //     id: 'homes_sold',
    //     //     label: 'Homes Sold',
    //     //     displayOption: 'both',
    //     //     dataType: 'count',
    //     //     twoYAxis: true,
    //     // },
    //     // {
    //     //     id: 'inventory',
    //     //     label: 'Inventory',
    //     //     displayOption: 'both',
    //     //     dataType: 'count',
    //     //     twoYAxis: true,
    //     // },
    //     {
    //         id: 'median_dom',
    //         label: 'Median Days on Market',
    //         displayOption: 'both',
    //         dataType: 'count',
    //         twoYAxis: false,
    //         badDirection: 'up',
    //         weighting: 1,
    //     },
    //     // {
    //     //     id: 'median_list_ppsf',
    //     //     label: 'Median List Price per Sqft',
    //     //     displayOption: 'regular',
    //     //     dataType: 'dollar',
    //     //     twoYAxis: false,
    //     // },
    //     // {
    //     //     id: 'median_list_price',
    //     //     label: 'Median List Price',
    //     //     displayOption: 'regular',
    //     //     dataType: 'dollar',
    //     //     twoYAxis: true,
    //     // },
    //     {
    //         id: 'median_ppsf',
    //         label: 'Median Sale Price per Sqft',
    //         displayOption: 'regular',
    //         dataType: 'dollar',
    //         twoYAxis: false,
    //         badDirection: 'down',
    //         weighting: 1,
    //     },
    //     // {
    //     //     id: 'median_sale_price',
    //     //     label: 'Median Sale Price',
    //     //     displayOption: 'regular',
    //     //     dataType: 'dollar',
    //     //     twoYAxis: true,
    //     // },
    //     // {
    //     //     id: 'new_listings',
    //     //     label: 'New Listings',
    //     //     displayOption: 'both',
    //     //     dataType: 'count',
    //     //     twoYAxis: true,
    //     // },
    //     {
    //         id: 'off_market_in_two_weeks',
    //         label: 'Off Market in Two Weeks',
    //         displayOption: 'both',
    //         dataType: 'percentage',
    //         twoYAxis: false,
    //         badDirection: 'down',
    //         weighting: .85,
    //     },
    //     // {
    //     //     id: 'pending_sales',
    //     //     label: 'Pending Sales',
    //     //     displayOption: 'both',
    //     //     dataType: 'count',
    //     //     twoYAxis: true,
    //     // },
    //     {
    //         id: 'price_drops',
    //         label: 'Price Drops',
    //         displayOption: 'both',
    //         dataType: 'percentage',
    //         twoYAxis: false,
    //         badDirection: 'up',
    //         weighting: 1,
    //     },
    //     {
    //         id: 'sold_above_list',
    //         label: 'Sold Above List',
    //         displayOption: 'both',
    //         dataType: 'percentage',
    //         twoYAxis: false,
    //         badDirection: 'down',
    //         weighting: .8,
    //     }
    // ]

    
    
    const refinedFipsMarketData = PullMarketData(fipsHousingMarketData, marketDataKeys, disaster_declarations_list)
    const refinedZipMarketData = PullMarketData(zipHousingMarketData, marketDataKeys, disaster_declarations_list)
    
    const refinedFipsMarketDataStateDisasters = PullMarketData(fipsHousingMarketData, marketDataKeys, disaster_declarations_list_state)
    const refinedZipMarketDataStateDisasters = PullMarketData(zipHousingMarketData, marketDataKeys, disaster_declarations_list_state)
    
    // console.log('refinedFipsMarketData ORIGINAL', refinedFipsMarketData, refinedZipMarketData)
    // console.log('refinedFipsMarketData STATE DISASTERS', refinedFipsMarketDataStateDisasters, refinedZipMarketDataStateDisasters)
    // Score the market data
    const marketScores = ScoreMarketData(refinedFipsMarketData, refinedZipMarketData, disaster_declarations_list, fipsData)
    // const marketScoresStateDisasters = ScoreMarketData(refinedFipsMarketDataStateDisasters, refinedZipMarketDataStateDisasters, disaster_declarations_list_state, fipsData)

    const newMarketScores = NEWScoreMarketData(
        refinedZipMarketData,
        refinedZipMarketDataStateDisasters,
        refinedFipsMarketData,
        refinedFipsMarketDataStateDisasters,
        filteredDisasterDeclarationsList,
        filteredDisasterDeclarationsListState,
        fipsData
    )
    // console.log('marketScores original', marketScores)
    // console.log('marketScores state disasters', marketScoresStateDisasters)
    // console.log('newMarketScores', newMarketScores)
    // ----------------- GET THE KEY DATA ------------------------------------------------------------------------------------------------

    // const LTVPriceOutData = PullLTVPriceOutData(propertyData, fipsData, zipData, fipsHousingMarketData, zipHousingMarketData, householdIncomeConfig)
    // console.log(`LTVPriceOutData:`, LTVPriceOutData)

    const county_name = fipsData.county_name
    const zip_code = propertyData.data.property_details.zip

    // HOUSING MARKET DATA

    const fips_census_income_data = fipsData.census_income_data
    const zip_census_income_data = zipData.census_income_data

    const fipsDataForChart = fips_census_income_data?.['2023'] || {};
    const zipDataForChart = zip_census_income_data?.['2023'] || {};

    const fipsChartData = LTVCalculators.prepareChartData(fipsDataForChart, householdIncomeConfig);
    const zipChartData = LTVCalculators.prepareChartData(zipDataForChart, householdIncomeConfig);

    const fips_current_income_median = fips_census_income_data['2023'].median_household_income;
    const fips_current_income_mean = fips_census_income_data['2023'].mean_household_income;

    const zip_current_income_median = zip_census_income_data['2023'].median_household_income;
    const zip_current_income_mean = zip_census_income_data['2023'].mean_household_income;

    // Calculate growth rates for all income metrics
    const fipsMedianIncomeGrowth = LTVCalculators.calculateCAGR(
        fips_census_income_data['2021'].median_household_income,
        fips_current_income_median
    );

    const fipsMeanIncomeGrowth = LTVCalculators.calculateCAGR(
        fips_census_income_data['2021'].mean_household_income,
        fips_current_income_mean
    );

    const zipMedianIncomeGrowth = LTVCalculators.calculateCAGR(
        zip_census_income_data['2021'].median_household_income,
        zip_current_income_median
    );

    const zipMeanIncomeGrowth = LTVCalculators.calculateCAGR(
        zip_census_income_data['2021'].mean_household_income,
        zip_current_income_mean
    );


    // Do the income levels, mean/median for both fips and zip, over the next 10 years, with the current level being the starting point
    const fipsMedian10Years = [];
    const fipsMean10Years = [];
    const zipMedian10Years = [];
    const zipMean10Years = [];

    for (let i = 0; i < 11; i++) {
        fipsMedian10Years.push(fips_current_income_median * Math.pow(1 + fipsMedianIncomeGrowth, i));
        fipsMean10Years.push(fips_current_income_mean * Math.pow(1 + fipsMeanIncomeGrowth, i));
        zipMedian10Years.push(zip_current_income_median * Math.pow(1 + zipMedianIncomeGrowth, i));
        zipMean10Years.push(zip_current_income_mean * Math.pow(1 + zipMeanIncomeGrowth, i));
    }

    // console.log(`zipMean10Years:`, zipMean10Years)
    // Calculate sums for each array
    const sums = {
        'fips-median': fipsMedian10Years.reduce((a, b) => a + b, 0),
        'fips-mean': fipsMean10Years.reduce((a, b) => a + b, 0),
        'zip-median': zipMedian10Years.reduce((a, b) => a + b, 0),
        'zip-mean': zipMean10Years.reduce((a, b) => a + b, 0)
    };

    // Find the highest sum
    const highest_income_level_geo = Object.entries(sums).reduce((a, b) => b[1] > a[1] ? b : a)[0];
    const incomeLevelCalculations = {
        'fips-median': {
            geo_type: 'fips',
            income_type: 'median',
            location: county_name,
            value_today: fips_current_income_median,
            growth_rate: fipsMedianIncomeGrowth,
            ten_year_values: fipsMedian10Years,
            sum_ten_year_value: sums['fips-median']
        },
        'fips-mean': {
            geo_type: 'fips',
            income_type: 'mean',
            location: county_name,
            value_today: fips_current_income_mean,
            growth_rate: fipsMeanIncomeGrowth,
            ten_year_values: fipsMean10Years,
            sum_ten_year_value: sums['fips-mean']
        },
        'zip-median': {
            geo_type: 'zip',
            income_type: 'median',
            location: `ZIP ${zip_code}`,
            value_today: zip_current_income_median,
            growth_rate: zipMedianIncomeGrowth,
            ten_year_values: zipMedian10Years,
            sum_ten_year_value: sums['zip-median']
        },
        'zip-mean': {
            geo_type: 'zip',
            income_type: 'mean',
            location: `ZIP ${zip_code}`,
            value_today: zip_current_income_mean,
            growth_rate: zipMeanIncomeGrowth,
            ten_year_values: zipMean10Years,
            sum_ten_year_value: sums['zip-mean']
        }
    }
    // console.log(`incomeLevelCalculations:`, incomeLevelCalculations)

    // Set the corresponding array as highest_income_level
    const highest_income_level = incomeLevelCalculations[highest_income_level_geo];

    // Get the datpoints from the property data
    const propertyDataDatpoints = propertyData?.data?.user_input_form || [];

    // GETTING THE STARTING VALUE OF THE HOME
    // Get the datapoint_value from the datapoint that has an id of '118'
    const homeSqft = propertyDataDatpoints.find(datapoint => datapoint.id === '118')?.datapoint_value;

    // Get the latest price per sqft from the zipHousingMarketData
    const latestPricePerSqft = zipHousingMarketData[0].median_ppsf;

    // Get the object with numeric keys
    const breakpointsObj = propertyData.data.scenario_modeling.individual_breakdowns[0]
        .financials_no_improvements_made.breakdown.property_value.value_vs_household_income_breakpoints;

    // Convert keys to numbers and find the minimum
    const minValue = Math.min(...Object.keys(breakpointsObj).map(Number));



    // GETTING THE MARKET GROWTH RATE
    // const ppsfMarketGrowthRates = CalculateMarketGrowthRates(zipHousingMarketData, 'median_ppsf');
    // const salePriceMarketGrowthRates = CalculateMarketGrowthRates(zipHousingMarketData, 'median_sale_price');


    // Get the total expenses for the property over the next 10 years and divide by 12 to get the monthly expenses
    const totalExpenses = propertyData.data.scenario_modeling.individual_breakdowns[0].financials_no_improvements_made.breakdown.opex.annual_total
    const current_monthly_expenses = totalExpenses[0].value / 12



    // ----------------- SET THE ORIGINAL VALUES ------------------------------------------------------------------------------------------------


    // Calculate the starting values for the states
    let currentHomeValueStarting;
    if (minValue) {
        currentHomeValueStarting = minValue;
    } else {
        currentHomeValueStarting = latestPricePerSqft * homeSqft;
    }
    const highest_income_today_calculated = highest_income_level.value_today

    const original_interest_rate = .055
    const original_down_payment = .05
    const original_income_spent_on_housing = .30
    const original_market_growth_rate = .05
    const original_user_income_growth_rate = .024

    // Calculate the original future home values
    const original_future_home_values = LTVCalculators.calculate_future_home_value(currentHomeValueStarting, original_market_growth_rate)

    // Calculate the original projected future income
    const original_projected_future_income = LTVCalculators.calculate_projected_future_income(highest_income_today_calculated, original_user_income_growth_rate)

    const percentageLevels = [
        { percentage: .30 },
        { percentage: .35 },
        { percentage: .40 },
        { percentage: .45 }
    ];

    const original_future_income_required = LTVCalculators.calculateFutureIncomeRequirements(percentageLevels, original_future_home_values, current_monthly_expenses, original_interest_rate, original_down_payment)
    const original_income_gaps = LTVCalculators.analyzeIncomeGaps(original_projected_future_income, original_future_income_required)
    // Comparison constants
    const incomeHigherInCounty = (fips_current_income_median + fips_current_income_mean) >
        (zip_current_income_median + zip_current_income_mean);

    const medianIncomeGrowingFasterInCounty = fipsMedianIncomeGrowth > zipMedianIncomeGrowth;

    const meanIncomeGrowingFasterInCounty = fipsMeanIncomeGrowth > zipMeanIncomeGrowth;

    // Get the scoring info for attractiveness and market signals
    const attractivenessScore = original_income_gaps.overallTrend.riskLevelScore
    const attractivenessRiskLevelText = original_income_gaps.overallTrend.riskLevelText
    const marketSignalsScore = Math.round(marketScores.riskLevelScore / 10)
    const marketSignalsRiskLevelText = marketScores.riskLevelText
    // Get the average of the two scores
    const combinedRiskLevelScore = Math.round((attractivenessScore + marketSignalsScore) / 2);

    // Set the props we want to pass to the LTVAttractiveness component
    const outputObject = {
        ltvScoring: {
            attractivenessScore: attractivenessScore,
            attractivenessRiskLevelText: attractivenessRiskLevelText,
            marketSignalsScore: marketSignalsScore,
            marketSignalsRiskLevelText: marketSignalsRiskLevelText,
            combinedRiskLevelScore: combinedRiskLevelScore
        },
        originalValues: {
            countyName: county_name,
            currentHomeValue: currentHomeValueStarting,
            currentMonthlyExpenses: current_monthly_expenses,
            disasterDeclarations: disaster_declarations_list,
            disasterDeclarationsState: disaster_declarations_list_state,
            disasterDeclarationsStateAllCounties: disaster_declarations_list_state_all_counties,
            downPayment: original_down_payment,
            fipsChartData: fipsChartData,
            futureHomeValues: original_future_home_values,
            incomeHigherInCounty: incomeHigherInCounty,
            highestIncomeLevel: highest_income_level,
            incomeGaps: original_income_gaps,
            incomeLevelCalculations: incomeLevelCalculations,
            incomeSpentOnHousing: original_income_spent_on_housing,
            interestRate: original_interest_rate,
            marketDataKeys: marketDataKeys,
            marketGrowthRate: original_market_growth_rate,
            medianIncomeGrowingFasterInCounty: medianIncomeGrowingFasterInCounty,
            meanIncomeGrowingFasterInCounty: meanIncomeGrowingFasterInCounty,
            projectedFutureIncome: original_projected_future_income,
            userIncomeGrowthRate: original_user_income_growth_rate,
            zipChartData: zipChartData,
            zipCode: zip_code
        },
        refinedMarketData: {
            newMarketScores: newMarketScores,
            marketScores: marketScores,
            fipsHousingMarketData: refinedFipsMarketData,
            zipHousingMarketData: refinedZipMarketData
        }
    };

    return outputObject;
}